









import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class SidebarMenu extends Vue {
  selected: string | null = null

  items: MenuItem[] = [
    // {
    //   title: 'Школы',
    //   path: '/schools',
    //   icon: 'read'
    // },
    // {
    //   title: 'Менеджеры',
    //   path: '/managers',
    //   icon: 'user'
    // },
    {
      title: 'Курсы',
      path: '/courses',
      icon: 'read'
    },
    {
      title: 'Анкеты',
      path: '/forms',
      icon: 'solution'
    },
    {
      title: 'Ассоциации',
      path: '/associations',
      icon: 'form'
    },
    {
      title: 'Заявки',
      path: '/requests',
      icon: 'star'
    },
    {
      title: 'Логи',
      path: '/logs',
      icon: 'bars'
    },
    {
      title: 'Настройки',
      path: '/settings',
      icon: 'setting'
    }
  ]

  goTo(item: MenuItem) {
    this.$router.push(item.path)
  }

  detectSelected() {
    const matched = _.sortBy(this.$route.matched || [], n => n.path.length)
    const item = this.items.find(item => matched.map(m => m.path).includes(item.path))

    return (this.selected = item ? item.path : null)
  }

  @Watch('$route', { immediate: true })
  onRouteChange() {
    this.detectSelected()
  }
}

interface MenuItem {
  title: string
  icon: string
  path: string
}
